import { render, staticRenderFns } from "./SampleLessons.vue?vue&type=template&id=be0c64a0&scoped=true&"
import script from "./SampleLessons.vue?vue&type=script&lang=js&"
export * from "./SampleLessons.vue?vue&type=script&lang=js&"
import style0 from "./SampleLessons.vue?vue&type=style&index=0&id=be0c64a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be0c64a0",
  null
  
)

export default component.exports